"use strict";
/**
 *
 * FormDateField/useFormDateField
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const date_1 = require("./date");
const FormContext_1 = require("../FormContext");
const DateInput_1 = require("./DateInput");
const react_plumb_1 = require("@domonda/react-plumb");
function useFormDateField(props) {
    const form = FormContext_1.useFormContext();
    const memoProps = react_plumb_1.useDeepMemoOnValue(props);
    const { required, path } = memoProps, config = __rest(memoProps, ["required", "path"]);
    const plumbRef = react_1.useRef(null);
    const [field] = react_1.useMemo(() => {
        // dispose on field change
        if (plumbRef.current && !plumbRef.current.disposed) {
            plumbRef.current.dispose();
        }
        return form.makeFormField(path, config);
    }, [form, memoProps]);
    if (plumbRef.current !== field.plumb) {
        plumbRef.current = field.plumb;
    }
    react_1.useEffect(() => () => {
        if (plumbRef.current && !plumbRef.current.disposed) {
            plumbRef.current.dispose();
        }
    }, []);
    const FormDateInput = react_1.useMemo(() => {
        const FormDateInput = (_a) => {
            var { children, className, popperClassName, calendarClassName, inputRef } = _a, rest = __rest(_a, ["children", "className", "popperClassName", "calendarClassName", "inputRef"]);
            const [{ value, validityMessage, disabled, readOnly }] = react_plumb_1.usePlumbState({
                plumb: field.plumb,
            });
            const [inputEl, setInputEl] = react_1.useState(null);
            react_1.useEffect(() => {
                if (inputEl) {
                    inputEl.setCustomValidity(validityMessage || '');
                    if (validityMessage) {
                        inputEl.reportValidity();
                    }
                }
            }, [validityMessage || '']);
            const handleChange = react_1.useCallback((date) => {
                field.setValue(date ? date_1.stripTime(date) : null);
                if (inputEl) {
                    // we want this asynchronously called because some browsers (safari) decide to hide the validity box on input
                    const { validity } = inputEl;
                    if (!validity.valid) {
                        const reportValidity = () => inputEl.reportValidity();
                        setTimeout(reportValidity, 0);
                    }
                }
            }, [field, inputEl]);
            const handleRef = react_1.useCallback((dateInput) => {
                if (dateInput) {
                    setInputEl(dateInput.input || null);
                    if (typeof inputRef === 'function') {
                        inputRef(dateInput.input || null);
                    }
                    else if (inputRef && inputRef.current) {
                        inputRef.current =
                            dateInput.input || null;
                    }
                }
            }, [inputRef]);
            return (react_1.default.createElement(DateInput_1.DateInput, Object.assign({ disabled: disabled, readOnly: readOnly }, rest, { ref: handleRef, required: required, selected: value && typeof value === 'string' ? date_1.parseISOToDate(value) : value, onChange: handleChange })));
        };
        return FormDateInput;
    }, [field, required]);
    return Object.assign(Object.assign({}, field), { DateInput: FormDateInput });
}
exports.useFormDateField = useFormDateField;
